import { useEffect, useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function StaticPage({ pageKey }) {
  const [page, setPage] = useState(null);
  useEffect(() => {
    api.get(`/pages/${pageKey}`).then(({ data }) => setPage(data)).catch(() => {});
  }, [pageKey]);

  return (
    <div className="on-dark violet-canvas fade-in flex-1 w-full">
      <div className="mx-auto max-w-2xl px-5 sm:px-8 py-12 sm:py-20">
        <SEO title={page?.title} />
        <h1 className="font-serif text-5xl font-light">{page?.title || "…"}</h1>
        <div className="mt-8 text-[#D8B9EA] leading-relaxed whitespace-pre-wrap">
          {page?.content}
        </div>
      </div>
    </div>
  );
}
